import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import {
  CreateGroupPayload,
  CreateGroupResponse,
  Group,
  ListGroupsResponse,
  ShowGroupResponse,
  UpdateGroupPayload,
  UpdateGroupResponse,
} from "./types";

import { route } from "../../utils";

export * from "./types";

const ENDPOINTS = {
  LIST: "/api/v2/org/:organization_id/user/:user_id/groups",
  SHOW: "/api/v2/org/:organization_id/user/:user_id/groups/:group_id",
  CREATE: "/api/v2/org/:organization_id/user/:user_id/groups",
  UPDATE: "/api/v2/org/:organization_id/user/:user_id/groups/:group_id",
  DELETE: "/api/v2/org/:organization_id/user/:user_id/groups/:group_id",
};

export class GroupsAPI {
  constructor(private client: CohesiveAPIClient) {}

  async list(config?: AxiosRequestConfig): Promise<Group[]> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.get<ListGroupsResponse>(
      route(ENDPOINTS.LIST, {
        organization_id: organizationId,
        user_id: userId,
      }),
      config,
    );

    return response.data.data.groups;
  }

  async show(groupId: string, config?: AxiosRequestConfig): Promise<Group> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.get<ShowGroupResponse>(
      route(ENDPOINTS.SHOW, {
        organization_id: organizationId,
        user_id: userId,
        group_id: groupId,
      }),
      config,
    );

    return response.data.data.group;
  }

  async create(
    data: CreateGroupPayload,
    config?: AxiosRequestConfig,
  ): Promise<Group> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.post<
      CreateGroupResponse,
      any,
      CreateGroupPayload
    >(
      route(ENDPOINTS.CREATE, {
        organization_id: organizationId,
        user_id: userId,
      }),
      data,
      config,
    );

    return response.data.data.group;
  }

  async update(
    groupId: string,
    data: UpdateGroupPayload,
    config?: AxiosRequestConfig,
  ): Promise<Group> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.put<
      UpdateGroupResponse,
      any,
      UpdateGroupPayload
    >(
      route(ENDPOINTS.UPDATE, {
        organization_id: organizationId,
        user_id: userId,
        group_id: groupId,
      }),
      data,
      config,
    );

    return response.data.data.group;
  }

  async delete(groupId: string, config?: AxiosRequestConfig): Promise<void> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    await this.client.axios.delete(
      route(ENDPOINTS.DELETE, {
        organization_id: organizationId,
        user_id: userId,
        group_id: groupId,
      }),
      config,
    );
  }
}
